import {
  addClass,
  addListener,
  closest,
  q,
  removeClass,
  triggerEvent,
} from "./utils";
import { modalMsgs, openConfirmModal, openChoiseModal } from "./modal";
import CustomForm from "./form";
import Validators from "./validators";
import BranchesList from "./branchesList";
import Req from "./req";

const branchInpt: any = q(".branch-input");
const branchNameInpt: any = q("#form-branch-name");
const branchIdInpt: any = q("#form-branch-id");
const branchPcInpt: any = q("#form-postal-code");
const phoneInpt: any = q("#form-phone");
const searchBtn: any = <Element>q(".search-button");
const form = new CustomForm(q(".vasos-section .form"));
const branches = new BranchesList(<Element>q(".vasos-section .branches-list"));

addListener("click", searchBtn, (e) => {
  e.preventDefault();
  const input: any = q("input", e.target.parentNode);
  const parent: any = closest(input, ".input-container");
  const rule = input.dataset["validate"];

  if (rule && Validators[rule](input.value)) {
    const endpoint = "/ebanking/public/promociones/vasos/sucursales";
    removeClass(parent, "input-invalid");
    removeClass(branchInpt, "hide input-invalid");

    branches.loading = true;
    branches.resetContainer();

    Req.post(endpoint, { codigoPostal: input.value }).then(
      ({ codigo, resultado }: any) => {
        branches.loading = false;
        branches.branches = resultado?.sucursales || [];
      }
    );
  } else {
    addClass(parent, "input-invalid");
  }

  branchIdInpt.value = "";
  branchNameInpt.value = "";
  branchPcInpt.value = "";
  triggerEvent("change blur", branchIdInpt);
  triggerEvent("change blur", branchNameInpt);
  triggerEvent("change blur", branchPcInpt);
});

branches.branchSelect.add(({ idSucursalCecos, nombre, codigoPostal }) => {
  branchIdInpt.value = idSucursalCecos;
  branchNameInpt.value = nombre;
  branchPcInpt.value = codigoPostal;
  triggerEvent("change blur", branchIdInpt);
  triggerEvent("change blur", branchNameInpt);
  triggerEvent("change blur", branchPcInpt);
});

form.submit.add(() => {
  openChoiseModal(modalMsgs.confirmPhone(phoneInpt.value), undefined, () => {
    const endpoint = "/ebanking/public/promociones/vasos/registro";
    addClass(document.body, "loading");
    Req.post(endpoint, form.getData()).then(({ codigo, fecha, folio }: any) => {
      removeClass(document.body, "loading");
      if (codigo === 0) {
        openConfirmModal(modalMsgs.successRegistration(fecha, folio));
      } else if (codigo === 1) {
        openConfirmModal(modalMsgs.invalidAccount());
      } else if (codigo === 2) {
        openConfirmModal(modalMsgs.outOfStock());
      } else if (codigo === 3) {
        openConfirmModal(modalMsgs.alreadyRegistered());
      } else if (codigo === 4) {
        openConfirmModal(modalMsgs.accountBlocked());
      } else if (codigo === 5) {
        openConfirmModal(modalMsgs.endOfPromo());
      } else {
        openConfirmModal(modalMsgs.error());
      }

      // Clear inputs.
      form.reset();
      branches.resetContainer();
      addClass(branchInpt, "hide");
    });
  });
});
